Object.defineProperty(exports,"__esModule",{value:true});var _platform=require("./../variables/platform");var _platform2=_interopRequireDefault(_platform);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=

function(){var variables=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_platform2.default;
var platform=variables.platform;

var fabTheme={
"NativeBase.Button":{
alignItems:"center",
padding:null,
justifyContent:"center",
"NativeBase.Icon":{
alignSelf:"center",
fontSize:20,
marginLeft:0,
marginRight:0},

"NativeBase.IconNB":{
alignSelf:"center",
fontSize:20,
marginLeft:0,
marginRight:0}}};




return fabTheme;
};
//# sourceMappingURL=Fab.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/native-base/dist/src/theme/components/Fab.js
// module id = 436
// module chunks = 0